<!-- 申请意向学生列表 -->
<template>
  <div>
    <div style="background: #fff"
         id="choose-fill">
      <Form ref="formValidate"
            :model="formValidate"
            :rules="ruleValidate">
        <div class="choose-intention"
             style="padding-bottom:0;">
          <div class="choose-intention-con">
            <FormItem prop="chooseReason">
              <p slot="label"
                 class="choose-intention-title"><span class="valid">申请意向 - 选择原因</span></p>
              <div style="margin-top:90px;">
                <editor ref="analysisEditor"
                        :cache=false
                        v-model="formValidate.chooseReason" />
              </div>
            </FormItem>
          </div>
        </div>
        <div class="choose-intention">
          <div class="choose-intention-con">
            <p class="choose-intention-title">其它申请意向</p>
            <div class="from-project">
              <ul>
                <li v-for=" (item, index) in formValidate.otherPurpose"
                    :key="index">
                  <div class="delete"
                       v-show="index !==0"
                       @click="handleDelete"></div>
                  <h1>项目 {{ index+1 | fillZero }}</h1>
                  <FormItem label="学校名称"
                            :prop="'otherPurpose.' + index + '.univer'">
                    <Select v-model="item.univer"
                            clearable
                            filterable
                            @on-change="handleSelectUniver(item,index)">
                      <Option v-for="(item,index) in universList"
                              :key="index"
                              :value="item">{{item}}</Option>
                    </Select>
                  </FormItem>
                  <FormItem label="其它学校名称"
                            :prop="'otherPurpose.' + index + '.otherUniver'"
                            v-if="item.univer === '其它学校'">
                    <Input v-model.trim="item.otherUniver"></Input>
                  </FormItem>
                  <FormItem label="学院名称"
                            :prop="'otherPurpose.' + index + '.college'"
                            v-if="item.univer !== '其它学校'">
                    <Select v-model="item.college"
                            clearable
                            filterable>
                      <Option v-for="(collegeItem,index) in item.collegeList"
                              :key="index"
                              :value="collegeItem">{{collegeItem}}</Option>
                    </Select>
                  </FormItem>
                  <FormItem label="其它学院"
                            :prop="'otherPurpose.' + index + '.otherCollege'"
                            v-if="item.college === '其它学院' || item.univer === '其它学校'">
                    <Input v-model.trim="item.otherCollege"></Input>
                  </FormItem>
                  <FormItem label="项目名称"
                            :prop="'otherPurpose.' + index + '.projectName'"
                            v-if="item.univer !== '其它学校'">
                    <Select v-model="item.projectName"
                            clearable
                            filterable
                            placeholder="e.g. PhD in Statistics">
                      <Option v-for="projectItem in item.projectList"
                              :key="projectItem.name"
                              :value="projectItem.name">{{projectItem.name}}</Option>
                    </Select>
                  </FormItem>
                  <FormItem label="其它项目名称"
                            :prop="'otherPurpose.' + index + '.otherProjectName'"
                            v-if="item.projectName === '其它项目' || item.univer === '其它学校'">
                    <Input v-model.trim="item.otherProjectName"></Input>
                  </FormItem>
                  <FormItem label="项目链接"
                            :prop="'otherPurpose.' + index + '.projectLink'">
                    <Input v-model="item.projectLink"
                           placeholder="e.g. https://www.harvard.edu/"></Input>
                  </FormItem>
                  <FormItem label="申请原因"
                            :prop="'otherPurpose.' + index + '.applyReason'">
                    <div style="margin-top:34px;">
                      <editor ref="analysisEditor"
                              :cache=false
                              v-model="item.applyReason" />
                    </div>
                  </FormItem>
                </li>
              </ul>
              <div class="add"
                  v-if="isallowedit"
                   @click="handleAdd">+ 添加更多 项目</div>
              <div class="from-btn"  v-if="isallowedit">
                <Button type="primary"
                        class="zlr-btn-priamry"
                        @click="handleSub"
                        :loading="isSub">提交意向</Button>
              </div>
            </div>
          </div>
        </div>
      </Form>
      <zlr-modal v-model="promptModal">
        <div class="intention-fill-prompt">
          <h1>确认提交意向反馈</h1>
          <div class="intention-prompt-con">{{promptCon}}</div>
          <div class="intention-fill-btn" v-if="isallowedit">
            <Button type="default"
                    class="zlr-btn-default"
                    @click="promptModal = false">关闭</Button>
            <Button type="primary"
                    class="zlr-btn-primary"
                    @click="handleSureSub">提交</Button>
          </div>
        </div>
      </zlr-modal>
    </div>
  </div>
</template>

<script>
import isAllowEdit from '@/view/mixins/is-edit'
// api
import { subtPreviewItemAddFeedback, subSchemeItemAddFeedback } from '@/api/preproject'
import { getOverseasUnivers, getOverseasProjectSimple, getOverseasCollegeNameList } from '@/api/overseas'
// components
import Editor from '_c/editor/editor'
import ZlrModal from '_c/modal/modal'
export default {
  name: '',
  mixins: [isAllowEdit],
  props: ['type'],
  components: {
    Editor,
    ZlrModal
  },
  data () {
    return {
      reason: '',
      promptModal: false,
      promptCon: '',
      id: this.$route.query.id,
      formValidate: {
        otherPurpose: [{}]
      },
      ruleValidate: {
        chooseReason: [{ required: true, message: '请输入选择原因' }]
      },
      isSub: false,
      universList: []
    }
  },
  computed: {},
  mounted () {
    this.getOverseasUnivers()
  },
  methods: {
    // 获取所有海校库学校
    getOverseasUnivers () {
      getOverseasUnivers({
        sourceNe: 'ADD_REQUEST'
      }).then(res => {
        let univers = res.data.model
        univers.push('其它学校')
        this.universList = univers
      })
    },
    // 根据学校增加项目
    getOverseasProjectSimple (univer, index) {
      getOverseasProjectSimple({
        univer
      }).then(res => {
        let data = res.data.model || []
        data.push({
          name: '其它项目'
        })
        this.$set(this.formValidate.otherPurpose[index], 'projectList', data)
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      })
    },
    // 根据学校查院校
    getOverseasCollegeNameList (univer, index) {
      getOverseasCollegeNameList({
        univer
      }).then((res) => {
        let data = res.data.model || []
        data.push('其它学院')
        this.$set(this.formValidate.otherPurpose[index], 'collegeList', data)
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      })
    },
    // 增加项目
    handleAdd () {
      this.formValidate.otherPurpose.push({})
    },
    // 删除项目
    handleDelete (index) {
      this.formValidate.otherPurpose.splice(index, 1)
    },
    // 提交
    handleSub () {
      if (!this.formValidate.chooseReason) {
        this.$zlr_message('申请意向 - 选择原因必填！', 'error')
        return
      }
      this.$refs['formValidate'].validate((valid) => {
        if (valid) {
          this.promptCon = this.type === 'preview' ? '当您提交意向反馈后，将不能对该项目初览再次进行修改！如您希望看到新的项目，可及时联系您的CD，与TA沟通' : '当您提交意向反馈后，将不能对该选校方案再次进行修改！如您有新的想法，可及时联系您的CD，与TA沟通'
          this.promptModal = true
        }
      })
    },
    handleSureSub () {
      this.promptModal = false
      let params = JSON.parse(JSON.stringify(this.formValidate))
      this.handleRepalceOther(params.otherPurpose, 'univer', 'otherUniver')
      this.handleRepalceOther(params.otherPurpose, 'projectName', 'otherProjectName')
      this.handleRepalceOther(params.otherPurpose, 'college', 'otherCollege')
      params.otherPurpose.forEach(item => {
        delete item.collegeList
        delete item.projectList
      })
      params.sourceId = this.id
      this.isSub = true
      this.subData(params).then(res => {
        this.$zlr_message('提交成功', 'success')
        let name = this.type === 'preview' ? 'project-choose-preview-list' : 'project-choose-scheme-list'
        this.$router.push({
          name
        })
      }).catch((error) => {
        this.$zlr_message(error.message, 'error')
      }).then(() => {
        this.isSub = false
      })
    },
    handleRepalceOther (data, cover, beCover) {
      data.forEach(item => {
        if (item[beCover]) {
          item[cover] = item[beCover]
        }
        delete item[beCover]
      })
    },
    subData (params) {
      return new Promise((resolve, reject) => {
        if (this.type === 'preview') {
          subtPreviewItemAddFeedback(params).then(res => {
            resolve(res)
          }).catch(error => {
            reject(error)
          })
        }
        if (this.type === 'scheme') {
          subSchemeItemAddFeedback(params).then(res => {
            resolve(res)
          }).catch(error => {
            reject(error)
          })
        }
      })
    },
    // 选择学校
    handleSelectUniver (item, index) {
      this.$set(this.formValidate.otherPurpose[index], 'otherUniver', '')
      this.$set(this.formValidate.otherPurpose[index], 'otherProjectName', '')
      this.$set(this.formValidate.otherPurpose[index], 'projectName', '')
      this.$set(this.formValidate.otherPurpose[index], 'college', '')
      this.$set(this.formValidate.otherPurpose[index], 'otherCollege', '')
      if (item.univer && item.univer !== '其它学校') {
        this.getOverseasCollegeNameList(item.univer, index)
        this.getOverseasProjectSimple(item.univer, index)
      } else {
        this.$set(this.formValidate.otherPurpose[index], 'collegeList', [])
        this.$set(this.formValidate.otherPurpose[index], 'projectList', [])
      }
    }
  }
}
</script>
<style lang='less' scoped>
.valid {
  position: relative;
  &::after {
    content: '*';
    position: absolute;
    top: 0;
    right: -6px;
    font-size: 12px;
    color: #f00;
  }
}
.intention-fill-prompt {
  width: 960px;
  h1 {
    font-size: 24px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 36px;
    font-weight: normal;
  }
  .intention-prompt-con {
    padding-top: 24px;
    padding-bottom: 32px;
  }
  .intention-fill-btn {
    text-align: right;
  }
  .zlr-btn-primary {
    margin-left: 24px;
  }
}
</style>
<style lang="less">
#choose-fill {
  .ivu-form-item-label::before {
    display: none;
  }
  .from-project {
    .ivu-select-dropdown {
      width: 640px;
    }
  }
}
</style>
